import Ferry from './ferry';

export default Ferry;
